<script>
import Vue from 'vue';

import "@backend/dist/css/style.min.css"
import "@backend/assets/custom_l9.scss"
import "@backend/assets/responsive_l9.scss"

import "@plugins/jquery-validation/jquery-validation.js"
// import "@backend/js/custom.js"
import "@backend/js/main.js"

Vue.component("draggable",()=>import("vuedraggable"))

// VueFormWizard
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import GlobalVue from '../helper/Global.vue';
Vue.use(VueFormWizard)

Vue.component("ImagePreview",()=>import("@backend/components/ImagePreview.vue"))
Vue.component("BoField",()=>import("@backend/components/BoField.vue"))
Vue.component("SortField",()=>import("@backend/components/SortField.vue"))
Vue.component("SortHandle",()=>import("@backend/components/SortHandle.vue"))
Vue.component("StatusLabel",()=>import("@backend/components/StatusLabel.vue"))
Vue.component("FileManager",()=>import("@components/FileManager.vue"))

export default {
  extends: GlobalVue,
  name:"BoMain",
  mounted(){
    this.refreshVariable()
    $(".preloader").hide()
  }
}
</script>

<template>
  <div class="BoMain">
    <div class="preloader" v-if="preloader">
      <div class="loader">
        <div class="loader__figure"></div>
        <p class="loader__label">Employee Facility System</p>
      </div>
    </div>
    <router-view/>
  </div>
</template>